import React, { CSSProperties, FC } from 'react'
import { Image } from 'semantic-ui-react'
import CircularLabel from '../../../../components/Labels/CircularLabel'
import { _MIXEDCOLORS } from '../../../../constants/colors'
import { createInitials } from '../../../../utils/createInitials'
import { IEmployee } from '../../../settings/types/employee'

interface Props {
  team: IEmployee[]
  space?: boolean
  size?: string
  showPointer?: boolean
  admins?: boolean
  toLeft?: number
}

const TeamGroupComponent: FC<Props> = ({ team, space, size, showPointer, admins, toLeft }) => {
  return (
    <React.Fragment>
      {team.map((e, i) => {
        /* Setting styles logic etc MUST be moved to selector */
        // Use deterministic color based on employee ID instead of random
        const colorIndex = typeof e.id === 'number' ? e.id % _MIXEDCOLORS.length : 0
        const left = space ? `${i}%` : `-${i * (toLeft ?? 5)}%`
        const style: CSSProperties = i === 0 ? { cursor: showPointer ? 'pointer' : 'default' } : { position: 'relative', left: left, cursor: showPointer ? 'pointer' : 'default' }
        const borderColor = admins || e.is_project_admin ? '#08D6A1' : '#ffffff'
        const _size = size ? size : '2.5rem'
        if (i <= 3) {
          const content = e.photo ?
            <Image
              circular={true}
              src={e.photo}
              style={{ width: `calc(${_size} - 2px)`, height: `calc(${_size} - 2px)`, minWidth: `calc(${_size} - 2px)`, minHeight: `calc(${_size} - 2px)`, objectFit: 'cover' }} />
            : createInitials(e)
          return <CircularLabel key={`${e.id}-emp`} style={style} height={_size} width={_size} content={content} color={e.photo ? '' : e.color ? e.color : _MIXEDCOLORS[colorIndex]} border={`2px solid ${borderColor}`} />
        } else if (i === 4) {
          const content = team.length - 4
          return <CircularLabel key={'total-team'} style={style} height={_size} width={_size} content={`+${content}`} color={'#232C58'} border={`2px solid #ffffff`} />
        } else {
          return null
        }
      })}
    </React.Fragment>
  )
}

export default React.memo(TeamGroupComponent)
